import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-certificatlist-table',
  templateUrl: './certificatlist-table.component.html',
  styleUrls: ['./certificatlist-table.component.css']
})
export class CertificatListTableComponent {
  @Input () appels?: any;


  onClick(){
    alert("Bouton clicked")
  }

}
